module.exports = __webpack_public_path__ + "static/media/gfl-web.07afc2b3.png";